import { render, staticRenderFns } from "./CreateInvoiceAdjustmentRuleModal.vue?vue&type=template&id=63c4f96f&scoped=true&"
import script from "./CreateInvoiceAdjustmentRuleModal.vue?vue&type=script&lang=js&"
export * from "./CreateInvoiceAdjustmentRuleModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateInvoiceAdjustmentRuleModal.vue?vue&type=style&index=0&id=63c4f96f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c4f96f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63c4f96f')) {
      api.createRecord('63c4f96f', component.options)
    } else {
      api.reload('63c4f96f', component.options)
    }
    module.hot.accept("./CreateInvoiceAdjustmentRuleModal.vue?vue&type=template&id=63c4f96f&scoped=true&", function () {
      api.rerender('63c4f96f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/InvoiceAdjustmentRule/Modals/CreateInvoiceAdjustmentRuleModal.vue"
export default component.exports